import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { IRegistrationLoginRequest, IRegistrationLoginSuccess } from '../models/registration-login.model';
import {
  loadRegisterRequest,
  loadRegisterSuccess,
  loadRegisterFailure,
  clearRegisterFailure,
  clearRegisterSuccess
} from '../actions/register.actions';

export const registerFeatureKey = 'register';

export interface RegisterState {
  isLoading: boolean;
  loadRegisterRequest: IRegistrationLoginRequest;
  loadRegisterSuccess: IRegistrationLoginSuccess;
  loadRegisterFailure: IGenericError<ErrorResponse>;
}

export const initialState: RegisterState = {
  isLoading: false,
  loadRegisterRequest: undefined,
  loadRegisterSuccess: undefined,
  loadRegisterFailure: undefined
};

export const reducer = createReducer(
  initialState,

  //#region REGISTER
  on(loadRegisterRequest, (state, action) => ({
    ...state,
    loadRegisterRequest: action.request,
    isLoading: true
  })),
  on(loadRegisterSuccess, (state, action) => ({
    ...state,
    loadRegisterSuccess: action.response,
    isLoading: false
  })),
  on(loadRegisterFailure, (state, action) => ({
    ...state,
    loadRegisterFailure: action.error,
    isLoading: false
  })),

  on(clearRegisterFailure, (state, action) => ({
    ...state,
    loadRegisterFailure: undefined
  })),
  on(clearRegisterSuccess, (state, action) => ({
    ...state,
    loadRegisterSuccess: undefined
  }))
  //#endregion
);

//#region REGISTER
export const getIsRegisterLoading = (state: RegisterState) => state.isLoading;
export const getRegisterRequest = (state: RegisterState) => state.loadRegisterRequest;
export const getRegisterSuccess = (state: RegisterState) => state.loadRegisterSuccess;
export const getRegisterFailure = (state: RegisterState) => state.loadRegisterFailure;

//#endregion
